import React from "react";
import styles from "./CardAdder.scss";
import { Icon } from "../../graphic";
import { Card } from "../Card";
import { PropTypes } from "prop-types";

export const CardAdder = (props) => {
    const { icon, minHeight } = props;
    return (
        <Card {...props} backgroundColor="transparent">
            <div className={styles.clicker}>
                <Icon className={styles.icon} name={icon} size="auto" />
            </div>
            <div className={styles.spacer} style={{ minHeight: minHeight }}></div>
        </Card>
    );
};

CardAdder.defaultProps = {
    icon: "plus",
    minHeight: "15em"
};

CardAdder.propTypes = {
    /**
     * Click handler
     */
    onClick: PropTypes.func,

    /**
     * Name of icon to use
     */
    icon: PropTypes.string,

    /**
     * Min height of adder
     */
    minHeight: PropTypes.any
};
